import { render, staticRenderFns } from "./FormularioAlterarSenha.vue?vue&type=template&id=f29a583a&scoped=true&"
import script from "./FormularioAlterarSenha.vue?vue&type=script&lang=js&"
export * from "./FormularioAlterarSenha.vue?vue&type=script&lang=js&"
import style0 from "./FormularioAlterarSenha.vue?vue&type=style&index=0&id=f29a583a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f29a583a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VForm,VTextField})
